import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';

Vue.config.productionTip = false
Vue.prototype.$bus=new Vue()
Vue.use(ElementUI);

Vue.filter('filterdate',(res)=>{
	return new Date(res).toLocaleString()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

